module.exports = __webpack_public_path__ + "static/media/sk.bcaf78c9.svg";